<template>
  <v-card elevation="0" style="border: 1px solid #111827">
    <v-row
      :class="[
        'd-flex justify-center align-center pa-12',
        $vuetify?.breakpoint?.smAndDown ? 'flex-column px-6' : '',
      ]"
    >
      <!-- 👉 Title above image only on mobile view -->
      <v-card-title v-if="$vuetify.breakpoint.smAndDown" class="product-title">
        <v-row no-gutters>
          <v-col
            :cols="$vuetify.breakpoint.smAndDown ? 12 : 12"
            class="d-flex align-center"
          >
            <div
              class="font-weight-bold w-100"
              :class="[$vuetify.breakpoint.smAndDown ? 'text-h6' : 'text-h5']"
            >
              {{ name }}
            </div>
          </v-col>
        </v-row>
      </v-card-title>

      <!-- 👉Image section - with controlled height -->
      <v-col
        :cols="$vuetify.breakpoint.smAndDown ? 12 : 5"
        class="d-flex justify-center align-center"
        :style="{
          width: $vuetify.breakpoint.xs ? '100%' : '21.875rem',
          marginBottom: $vuetify.breakpoint.smAndDown ? '1rem' : '0',
        }"
      >
        <v-img
          :src="item_image"
          :alt="name"
          contain
          max-height="350"
          class="p-4"
        ></v-img>
      </v-col>

      <!-- 👉 Content section -->
      <v-col
        :cols="$vuetify.breakpoint.smAndDown ? 12 : 7"
        class="product-information__container"
      >
        <!-- 👉 Title beside image only on desktop view -->
        <v-card-title
          v-if="!$vuetify.breakpoint.smAndDown"
          class="pb-1 pt-0 pe-0"
        >
          <v-row no-gutters>
            <v-col
              :cols="$vuetify.breakpoint.smAndDown ? 12 : 9"
              class="d-flex align-center"
            >
              <div
                class="font-weight-bold w-100"
                :class="[$vuetify.breakpoint.smAndDown ? 'text-h6' : 'text-h5']"
              >
                {{ name }}
              </div>
            </v-col>

            <!-- <v-col cols="3">
            <v-container>
              <v-row class="d-flex justify-end">
                <v-btn
                  class="px-4"
                  color="primary"
                  @click="openProductDetailsDialog"
                  :small="$vuetify?.breakpoint?.smAndDown"
                  :x-small="$vuetify?.breakpoint?.xsOnly"
                >
                  Details
                </v-btn>
              </v-row>
            </v-container>
          </v-col> -->
          </v-row>
        </v-card-title>

        <v-card-text
          :class="[$vuetify.breakpoint.smAndDown ? 'text-center px-0' : '']"
        >
          <div
            class="mb-1"
            :class="[
              $vuetify.breakpoint.smAndDown ? 'text-body-2' : 'text-body-1',
            ]"
          >
            {{ `¥${formatPrice(price)}` }}
          </div>

          <div
            :class="[
              $vuetify.breakpoint.smAndDown ? 'text-body-2' : 'text-body-1',
            ]"
          >
            <div class="mb-1">
              <span class="">味の種類:</span>
              {{ `${tasteType}` }}
            </div>

            <div class="mb-1">
              <span class="">酒の種類:</span>
              {{ `${ingredientType.length > 0 ? ingredientType : ""}`.trim() }}
            </div>

            <div class="mb-1">
              <span>容量:</span>
              {{ `${volume}` }}
            </div>

            <div class="mb-1">
              <span>その他の容量項目:</span>
              {{
                `${
                  volumeVariant?.length === 0 || volumeVariant == null
                    ? "なし"
                    : volumeVariant
                }`
              }}
            </div>
            <div class="drinking-temparature-image__container">
              <span class="font-weight-bold">飲みごろ温度</span>
              <v-img
                :src="drinkingTemparatureImagePath"
                :alt="name"
                contain
                class="pt-2"
                :width="$vuetify.breakpoint.smAndDown ? '100%' : '30rem'"
              />
            </div>
          </div>
        </v-card-text>
      </v-col>
    </v-row>

    <v-card-actions>
      <v-row class="d-flex justify-center align-center">
        <!-- Collapse button when not expanded -->
        <span
          v-if="!isExpanded"
          class="custom-collapse__btn"
          @click="isExpanded = true"
        >
          <h3 class="custom-collapse__txt">詳しくみる</h3>

          <svg
            width="40"
            height="40"
            viewBox="0 0 64 64"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            fill="none"
            stroke="#000000"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="collapse-icon"
          >
            <path d="M48 32 L32 48 L16 32 M48 16 L32 32 L16 16" />
          </svg>
        </span>

        <!-- Expandable content with transition -->
        <transition
          name="collapse"
          @enter="startTransition"
          @leave="endTransition"
        >
          <div v-if="isExpanded" class="custom-collapse__content">
            <!-- Slot for card content -->
            <slot>
              <ProductCarousel :items="childItems" />
              <div
                :class="[
                  'text-center mb-2 px-10',
                  $vuetify.breakpoint.mdAndDown ? '' : 'px-8',
                ]"
              >
                <h3 class="font-weight-bold green-heading-text">味わい</h3>
                <span class="text-justify"> {{ description }}</span>
              </div>
              <div class="text-center mb-2">
                <h3 class="font-weight-bold green-heading-text">
                  おすすめのペアリング
                </h3>
                <div>
                  <div class="line-gap">
                    <h3 class="font-weight-bold">《和食》</h3>
                    <ul :style="{ listStyleType: 'none', paddingLeft: '0' }">
                      <li
                        v-for="(item, index) in recommendedJapaneseFood"
                        :key="index"
                      >
                        {{
                          `${
                            recommendedJapaneseFood.length > 0
                              ? item
                              : "Unknown"
                          }`
                        }}
                      </li>
                    </ul>
                  </div>
                  <div class="line-gap">
                    <h3 class="font-weight-bold">《洋食》</h3>
                    <ul :style="{ listStyleType: 'none', paddingLeft: '0' }">
                      <li
                        v-for="(item, index) in recommendedWesternFood"
                        :key="index"
                      >
                        {{
                          `${
                            recommendedWesternFood.length > 0 ? item : "Unknown"
                          }`
                        }}
                      </li>
                    </ul>
                  </div>
                  <div class="line-gap">
                    <h3 class="font-weight-bold">《中華・エスニック》</h3>
                    <ul :style="{ listStyleType: 'none', paddingLeft: '0' }">
                      <li
                        v-for="(item, index) in recommendedChineseAndEthnicFood"
                        :key="index"
                      >
                        {{
                          `${
                            recommendedChineseAndEthnicFood.length > 0
                              ? item
                              : "Unknown"
                          }`
                        }}
                      </li>
                    </ul>
                  </div>
                  <div class="line-gap">
                    <h3 class="font-weight-bold">《スイーツ・フルーツ》</h3>
                    <ul :style="{ listStyleType: 'none', paddingLeft: '0' }">
                      <li
                        v-for="(item, index) in recommendedSweetsAndFruit"
                        :key="index"
                      >
                        {{
                          `${
                            recommendedSweetsAndFruit.length > 0
                              ? item
                              : "Unknown"
                          }`
                        }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </slot>

            <!-- Close button -->
            <span
              :style="isExpanded && { marginTop: '3em' }"
              class="custom-collapse__btn"
              @click="isExpanded = false"
            >
              <h3 class="custom-collapse__txt">閉じる</h3>

              <svg
                class="collapse-icon collapse-icon__up"
                width="40"
                height="40"
                viewBox="0 0 64 64"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                fill="none"
                stroke="#000000"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M48 32 L32 48 L16 32 M48 16 L32 32 L16 16" />
              </svg>
            </span>
          </div>
        </transition>
      </v-row>
    </v-card-actions>

    <!-- <v-card-actions class="py-0 ps-4 pe-0">
          <v-spacer></v-spacer>
          <div>
            <v-row>
              <v-dialog v-model="showRatingsDialog" max-width="600px">
                <v-form ref="ratingForm" v-model="isRatingFormValid">
                  <v-card>
                    <v-card-title> </v-card-title>
                    <v-card-text class="py-0">
                      <v-row class="d-flex align-center">
                        <v-col>
                          <p class="font-weight-bold text-subtitle-1 pe-4">
                            この飲料を飲んだことがありますか？
                          </p>
                          <v-container fluid>
                            <v-radio-group
                              class="my-0 py-0"
                              v-model="isTastedBefore"
                              column
                              :rules="[
                                (v) =>
                                  !!v ||
                                  'At least one option must be selected!',
                              ]"
                            >
                              <v-radio label="はい" value="yes"></v-radio>
                              <v-radio label="いいえ" value="no"></v-radio>
                            </v-radio-group>
                          </v-container>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions class="pa-4">
                      <v-spacer></v-spacer>
                      <v-btn
                        class="px-4"
                        color="primary"
                        @click="submitRatingsWithFeedback"
                        :small="$vuetify?.breakpoint?.smAndDown"
                        :x-small="$vuetify?.breakpoint?.xsOnly"
                      >
                        Submit
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </v-dialog>
              <v-btn
                color="primary lighten-2"
                class="ma-2"
                dark
                icon
                @click="handleRatingThumbsUp"
              >
                <v-icon>{{
                  submittedRatingType === "up"
                    ? "mdi-thumb-up"
                    : "mdi-thumb-up-outline"
                }}</v-icon>
              </v-btn>
              <v-btn
                color="primary lighten-2"
                class="ma-2"
                dark
                icon
                @click="handleRatingThumbsDown"
              >
                <v-icon>{{
                  submittedRatingType === "down"
                    ? "mdi-thumb-down"
                    : "mdi-thumb-down-outline"
                }}</v-icon>
              </v-btn>
            </v-row>
          </div>
        </v-card-actions> -->
    <div>
      <ProductDetails
        :isOpenDialog.sync="showItemDetailsDialog"
        :selectedProduct="productDetails"
      />
    </div>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";
import ProductDetails from "./ProductDetails.vue";
import axios from "axios";
import ProductCarousel from "./ProductCarousel.vue";

export default {
  name: "ProductCard",
  components: {
    ProductDetails,
    ProductCarousel,
  },
  computed: {
    ...mapGetters("credentials_form", ["credentialsFromData"]),
    productDetails() {
      return {
        id: this.id,
        name: this.name,
        image: this.item_image,
        price: this.formatPrice(this.price),
        description: this.description,
        categories: this.categories,
        tasteType: this.tasteType,
        ingredientType: this.ingredientType,
        volume: this.volume,
        volumeVariant: this.volumeVariant,
        childItems: this.childItems,
        recommendedWayToDrink: this.recommendedWayToDrink,
        recommendedJapaneseFood: this.recommendedJapaneseFood,
        recommendedWesternFood: this.recommendedWesternFood,
        recommendedChineseAndEthnicFood: this.recommendedChineseAndEthnicFood,
        recommendedSweetsAndFruit: this.recommendedSweetsAndFruit,
      };
    },
    drinkingTemparatureImagePath() {
      return require(`@/assets/drinking_temparature_images/${
        this.name + this.volume
      }.png`);
    },
  },
  data() {
    return {
      showItemDetailsDialog: false,
      isRatingFormValid: false,
      isTastedBefore: null,
      feedbackTextForRating: "",
      showRatingsDialog: false,
      submittedRatingType: null,
      temporaryRatingType: null,
      isExpanded: false,
    };
  },
  props: {
    id: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    item_image: {
      type: String,
      default: "",
    },
    price: {
      type: Number,
      default: 0,
    },
    description: {
      type: String,
      default: "",
    },
    category: {
      type: String,
      default: "",
    },
    averageRating: {
      type: Number,
      default: 0,
    },
    userRatingsTotal: {
      type: Number,
      default: 0,
    },
    tasteType: {
      type: Array,
      default: () => [],
    },
    ingredientType: {
      type: Array,
      default: () => [],
    },
    volume: {
      type: Array,
      default: () => [],
    },
    volumeVariant: {
      type: Array,
      default: () => [],
    },
    childItems: {
      type: Array,
      default: () => [],
    },
    recommendedWayToDrink: {
      type: Array,
      default: () => [],
    },
    recommendedJapaneseFood: {
      type: Array,
      default: () => [],
    },
    recommendedWesternFood: {
      type: Array,
      default: () => [],
    },
    recommendedChineseAndEthnicFood: {
      type: Array,
      default: () => [],
    },
    recommendedSweetsAndFruit: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    openProductDetailsDialog() {
      this.showItemDetailsDialog = true;
    },
    formatPrice(price) {
      // Convert to string and split by decimal point
      const [integerPart, decimalPart] = price.toString().split(".");

      // Format the integer part with commas
      const formattedInteger = integerPart.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        ","
      );

      // Return with decimal part if it exists
      if (decimalPart !== undefined) {
        return `${formattedInteger}.${decimalPart}`;
      } else {
        return formattedInteger;
      }
    },
    truncateText(text, length) {
      if (text.length <= length) {
        return text;
      }
      return text.slice(0, length) + "...";
    },
    handleRatingThumbsUp() {
      this.temporaryRatingType = "up";
      this.showRatingsDialog = true;
    },
    handleRatingThumbsDown() {
      this.temporaryRatingType = "down";
      this.showRatingsDialog = true;
    },
    submitRatingsWithFeedback() {
      if (!this.$refs.ratingForm.validate()) {
        return;
      }
      // this.isSubmittingRating = true;

      // Set feedback based on radio selection
      if (this.isTastedBefore === "yes") {
        this.feedbackTextForRating = "過去に飲んだことがある商品";
      } else {
        this.feedbackTextForRating = "まだ飲んだことがない商品";
      }

      const headers = {
        accept: "application/json",
        "project-key": this.credentialsFromData["projectKey"],
        "api-key": this.credentialsFromData["apiKey"],
      };

      const ratingRequestBody = {
        user_id: this.$root.userId,
        // member_id: this.$root.memberId,
        item_id: this.id,
        rating: this.temporaryRatingType === "up" ? 1 : 0,
        feedback: this.feedbackTextForRating,
      };

      axios
        .post(
          `${process.env.VUE_APP_RECOMMENDER_API}/v1/items/rating`,
          ratingRequestBody,
          { headers }
        )
        .then((response) => {
          if (response.status === 200) {
            // Only set the submitted rating after successful API response
            this.submittedRatingType = this.temporaryRatingType;
            this.showRatingsDialog = false;
            this.feedbackTextForRating = "";
          }
        })
        .catch((error) => {
          console.error("Rating submission failed:", error);
        })
        .finally(() => {
          // this.isSubmittingRating = false;
          this.temporaryRatingType = null;
        });
    },

    startTransition(el, done) {
      const height = el.scrollHeight;
      el.style.height = "0px";

      // Force browser to recognize the change before animating
      setTimeout(() => {
        el.style.height = height + "px";
      }, 10);
    },
    endTransition(el, done) {
      const height = el.scrollHeight;
      el.style.height = height + "px";

      // Force browser to recognize the change before animating
      setTimeout(() => {
        el.style.height = "0px";
      }, 10);
    },
  },
  mounted() {},
};
</script>

<style scoped>
.line-gap {
  margin-bottom: 1rem;
}
.text-truncate-three-lines {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.body-text-container {
  --body-font-size-desktop: 1rem;
  --body-font-size-tablet: 0.875rem;
  --body-font-size-mobile: 0.8125rem;
}

.body-text {
  font-size: var(--body-font-size-desktop) !important;
  transition: all 0.3s ease;
}

.green-heading-text {
  color: #006934;
}

.custom-collapse__btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: transform 0.3s ease;
  margin: 0 0 25px 0;
}

.custom-collapse__btn:hover {
  transform: translateY(3px);
}

.custom-collapse__txt {
  margin-bottom: 4px;
}

.custom-collapse__content {
  width: 100%;
  overflow: hidden;
  transition: height 0.4s ease-in-out, opacity 0.4s ease;
}

/* Transition classes */
.collapse-enter-active,
.collapse-leave-active {
  transition: all 0.4s ease;
}

.collapse-enter-from,
.collapse-leave-to {
  opacity: 0;
  height: 0 !important;
}
/* Icon animation */
.collapse-icon {
  transition: transform 0.3s ease;
}
.collapse-icon__up {
  transform: rotate(180deg);
}
.drinking-temparature-image__container {
  padding-top: 0.5rem;
}
.product-title {
}
.product-information__container {
  display: flex;
  flex-direction: column;
  padding: 0;
}
@media (max-width: 600px) {
  .body-text {
    font-size: var(--body-font-size-mobile) !important;
  }
  .product-title {
    padding: 0 0 0.25rem 0;
    text-align: center;
  }
  /* .product-information__container {
  display:  flex;
  flex-direction: column;
} */
}
</style>
